import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

// Glyph source: Material Symbols, Apache-2.0.
const ChatAddIcon = ({ fill, height, viewBox, width, ...rest }) => (
    <SvgIcon height={height} viewBox={viewBox} width={width} {...rest}>
        <path
            d="M120-160v-600q0-33 23.5-56.5T200-840h480q33 0 56.5 23.5T760-760v203q-10-2-20-2.5t-20-.5q-10 0-20 .5t-20 2.5v-203H200v400h283q-2 10-2.5 20t-.5 20q0 10 .5 20t2.5 20H240L120-160Zm160-440h320v-80H280v80Zm0 160h200v-80H280v80Zm400 280v-120H560v-80h120v-120h80v120h120v80H760v120h-80ZM200-360v-400 400Z"
            fill={fill}
        />
    </SvgIcon>
);

ChatAddIcon.propTypes = {
    fill: string,
    height: string,
    viewBox: string,
    width: string,
};

ChatAddIcon.defaultProps = {
    fill: MIGRATED_COLORS.black,
    height: '24',
    viewBox: '0 -960 960 960',
    width: '24',
};

export default ChatAddIcon;
